export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    submit: 'Отправить',
    save: 'Сохранить',
    usernameRequired: 'Введите имя пользователя!',
    passwordRequired: 'Введите пароль!',
    viewMore: 'Смотреть ещё',
    refreshSuccess: 'Обновлено',
    noMore: 'Больше нет данных',
    emptyData: 'Нет данных',
  },
  footer: { home: 'Главная', lottery: 'Лотерея', game: 'Бронь', video: 'Видео', mine: 'Профиль' },
  lang: { title: 'Язык / Language', current: 'Текущий язык' },
  home: {
    recommendedTasks: 'Рекомендуемые задания',
    popularRanking: 'Рейтинг популярности',
    hotRecommend: 'Горячие новинки',
    playCount: 'Просмотров: {count}',
    noticeLoading: 'Загрузка...',
  },
  game: {
    hallTitle: 'Зал бронирования',
    categoryAll: 'Все',
  },
  choose: {
    title: 'Компаньонки',
    tabCities: 'Каталог городов',
    tabProcess: 'Процесс и цены',
    privacyNotice: 'Самые настоящие компаньонки, бизнес-эскорт и местные свидания во всём интернете. Для защиты личных данных каждого пользователя вступить можно только через администратора или по рекомендации проверенного старшего участника.',
    resourcesQ: 'Какие варианты есть?',
    resourcesA: 'Модели из соцсетей, манекенщицы, стюардессы, молодые модели и студентки — чего только пожелаете, всё устроим.',
    scopeQ: 'Зона обслуживания?',
    scopeA: 'Бесплатные встречи в своём городе, выезд в любую точку страны. Есть во всех крупных городах; в небольших городах встречу организует администратор.',
    book: 'Бронь',
    contactConcierge: 'Обратитесь к консультанту или администратору',
    cityNames: {
      beijing: 'Пекин',
      shanghai: 'Шанхай',
      guangzhou: 'Гуанчжоу',
      shenzhen: 'Шэньчжэнь',
      nanjing: 'Нанкин',
      changsha: 'Чанша',
      chongqing: 'Чунцин',
      xian: 'Сиань',
    },
  },
  lottery: {
    gameRecord: 'История заданий',
    orderList: 'Лист задания',
    orderItemDetail: '1 ставка X {money} = {money}',
    clearOrder: 'Очистить лист',
    confirmSubmit: 'Подтвердить и отправить',
    availableBalance: 'Доступный баланс',
    yuan: 'юаней',
    currentPick: 'Текущий выбор: ',
    amountPerBet: 'Сумма одной ставки: ',
    amountPlaceholder: 'Введите сумму',
    amountInvalid: 'Неверная сумма!',
    fillAmount: 'Пожалуйста, введите сумму!',
    selectNumberFirst: 'Пожалуйста, выберите номера!',
    insufficientBalance: 'Недостаточно средств, свяжитесь со службой поддержки для пополнения!',
    notSelected: 'Не выбрано',
    contactAdminForTask: 'Свяжитесь с администратором, чтобы открыть это задание!',
    drawSuccess: 'Розыгрыш проведён, тираж: {expect}',
    periodNumber: 'Тираж',
    betUnit: 'ставок',
    totalAmountLabel: 'Общая сумма: ',
    totalCountLabel: 'Всего ставок: ',
    drawResult: 'Числа розыгрыша',
    big: 'Большое',
    small: 'Малое',
    single: 'Нечёт',
    doubleNum: 'Чёт',
    rules: {
      title: 'Правила игры',
      tipTitle: 'Как играть',
      tipDetail: 'Выбирайте номера из доступных вариантов сумм, чтобы сделать ставку.',
      winTitle: 'Условия выигрыша',
      winDetail: 'Сумма трёх выпавших чисел от 11 до 18 — Большое; от 3 до 10 — Малое.',
      exampleTitle: 'Пример ставки',
      exampleDetail: 'Ставка: Малое. Выпавшие числа: 123 — результат: Малое.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Пополнение', withdraw: 'Вывод', game: 'Ставка' },
    },
    withdraw: {
      amountLabel: 'Сумма вывода (юани)',
      all: 'Всё',
      limitRule1: '1. Лимит за раз: минимум {min}, максимум {max}',
      limitRule2: '2. Количество выводов: не более {num} раз в день',
      limitRule3: '3. Время зачисления: обычно около 5 минут, быстрее всего — 2 минуты',
      limitTitle: 'Условия лимитов',
      balanceLabel: 'Баланс: ',
      submit: 'Вывести сейчас',
      amountInvalid: 'Пожалуйста, введите корректную сумму',
    },
    bindCard: {
      formLabel: 'Пожалуйста, введите данные карты для получения средств',
      bankidLabel: 'Номер карты',
      bankidPlaceholder: 'Введите реальный номер карты',
      bankLabel: 'Название банка',
      bankPlaceholder: 'Выберите банк',
      notice: 'Уважаемый пользователь, в целях защиты ваших средств укажите настоящее имя и установите пароль для вывода. Если имя не совпадает с владельцем счёта, вывод невозможен.',
      submit: 'Подтвердить привязку',
      bankidRequired: 'Введите номер карты!',
      bankRequired: 'Выберите банк!',
    },
    setbank: {
      title: 'Карта для получения средств',
      addCard: 'Добавить карту для получения средств',
      tips: 'Примечание: привяжите крупный коммерческий банк. Если требуется изменение, свяжитесь с онлайн-службой поддержки.',
      setNameFirst: 'Сначала укажите имя, затем привяжите банковскую карту!',
      setPayPasswordFirst: 'Сначала установите пароль для вывода, затем привяжите банковскую карту!',
    },
    setPayPassword: {
      firstPrompt: 'Введите пароль для вывода',
      secondPrompt: 'Введите пароль для вывода ещё раз',
      incomplete: 'Пожалуйста, заполните полностью',
      mismatch: 'Пароли не совпадают!',
    },
    setLoginPassword: {
      oldPassword: 'Старый пароль',
      oldPasswordPlaceholder: 'Введите ваш старый пароль',
      newPassword: 'Новый пароль',
      newPasswordPlaceholder: 'Введите ваш новый пароль',
      confirmPasswordPlaceholder: 'Введите ваш новый пароль ещё раз',
      incomplete: 'Пожалуйста, заполните полностью!',
      mismatch: 'Пароли не совпадают',
    },
    setname: {
      nameLabel: 'Имя',
      namePlaceholder: 'Введите ваше настоящее имя',
      notice: 'Для безопасности счёта настоящее имя должно совпадать с именем владельца привязанной банковской карты',
      alreadySet: 'Не задавайте его повторно!',
      nameRequired: 'Введите ваше имя!',
    },
    setsex: {
      male: 'Мужской',
      female: 'Женский',
    },
    infomation: {
      avatar: 'Аватар',
      chooseAvatar: 'Выбрать аватар',
      realName: 'Настоящее имя',
      notSet: 'Не указано',
      gender: 'Пол',
      unknown: 'Неизвестно',
      bindInfo: 'Данные привязки',
      bound: 'Привязано',
      none: 'Нет',
    },
    index: {
      recharge: 'Пополнить',
      withdraw: 'Вывести',
      myWallet: 'Мой кошелёк',
      details: 'Подробнее',
      balanceLabel: 'Баланс: ',
      personalReport: 'Личный отчёт',
      accountDetail: 'Детализация счёта',
      profileCenter: 'Личный кабинет',
      notice: 'Объявления',
      customerService: 'Онлайн-поддержка',
      completeTaskFirst: 'Сначала завершите регистрацию',
      contactServiceToRecharge: 'Обратитесь в онлайн-поддержку для пополнения',
      setPayoutCardFirst: 'Сначала добавьте карту для вывода',
      featureDisabled: 'Эта функция пока недоступна',
      accountOffline: 'Аккаунт отключён',
      loginRegister: 'Вход / Регистрация',
      loginHint: 'Войдите, чтобы посмотреть',
    },
    setting: {
      basicInfo: 'Основная информация',
      loginPassword: 'Пароль для входа',
      payPassword: 'Платёжный пароль',
      payPasswordAlreadySet: 'Платёжный пароль уже установлен!',
      signOut: 'Выйти',
    },
    gameRecord: {
      betAmount: 'Сумма ставки: {money}',
      betTime: 'Время ставки: {time}',
      settleTime: 'Время расчёта: {time}',
    },
    withdrawRecord: {
      amount: 'Сумма вывода: {money}',
      desc: 'Примечание к выводу: {desc}',
      submitTime: 'Время заявки: {time}',
      reviewTime: 'Время проверки: {time}',
    },
    report: {
      profitLabel: 'Прибыль/убыток',
      formulaTip: 'Прибыль = выигрыш - ставки + пополнения - выводы',
      playAmount: 'Сумма ставок',
      rechargeAmount: 'Сумма пополнений',
      withdrawAmount: 'Сумма выводов',
      winAmount: 'Сумма выигрышей',
    },
    service: {
      contact: 'Связаться сейчас',
      slogan: 'Свяжитесь с нами по любому вопросу',
    },
  },
  video: {
    hallTitle: 'Видеотеатр',
    hotRecommend: 'Горячие новинки',
    playCount: 'Просмотров: {count}',
    playCountSuffix: '{count} просмотров',
    rechargeToWatch: 'Пополните баланс, чтобы смотреть видео!',
  },
  recharge: {
    title: 'Пополнение',
    chooseCoin: 'Выберите валюту',
    address: 'Адрес для пополнения',
    copy: 'Копировать адрес',
    copied: 'Скопировано',
    amount: 'Сумма пополнения',
    uploadShot: 'Загрузить скриншот перевода',
    submit: 'Отправить заявку на пополнение',
    pending: 'На проверке',
    done: 'Зачислено',
    rejected: 'Отклонено',
  },
  payMethod: {
    title: 'Выберите способ получения',
    bankCard: 'Банковская карта',
    wallet: 'Криптокошелёк',
    unbind: 'Отвязать',
    bindNew: 'Привязать новый адрес',
    confirmUnbind: 'Отвязать этот способ получения?',
    payPassword: 'Пароль вывода',
    wrongPassword: 'Неверный пароль вывода',
    chooseFirst: 'Сначала выберите способ получения',
  },
  router: {
    Index: { title: 'Главная' },
    Home: { title: 'Главная' },
    Choose: { title: 'Компаньонки' },
    List: { title: 'Список компаньонок' },
    Profile: { title: 'Профиль компаньонки' },
    Mine: { title: 'Профиль' },
    Video: { title: 'Видео' },
    Game: { title: 'Игры' },
    Login: { title: 'Вход' },
    Register: { title: 'Регистрация' },
    ServiceOnline: { title: 'Служба поддержки' },
    ServicePage: { title: 'Служба поддержки' },
    Setting: { title: 'Настройки' },
    Infomation: { title: 'Основная информация' },
    Setname: { title: 'Изменить имя' },
    Setsex: { title: 'Изменить пол' },
    SetPayPassword: { title: 'Платёжный пароль' },
    SetLoginPassword: { title: 'Пароль для входа' },
    Lottery: { title: 'Лотерея' },
    Notice: { title: 'Объявления' },
    PlayVideo: { title: 'Воспроизведение видео' },
    Setbank: { title: 'Добавить карту для выплат' },
    BindCard: { title: 'Добавить карту для выплат' },
    Withdraw: { title: 'Вывод' },
    Recharge: { title: 'Пополнение' },
    Personalreport: { title: 'Личный отчёт' },
    WithdrawRecord: { title: 'История выводов' },
    AccountDetail: { title: 'Детали счёта' },
    GameRecord: { title: 'История игр' },
  },
  captcha: {
    placeholder: 'Код с картинки',
    refresh: 'Нажмите, чтобы обновить',
    error: 'Неверный проверочный код',
    required: 'Введите код с картинки',
  },
  login: {
    title: 'Вход',
    usernamePlaceholder: 'Введите имя пользователя',
    passwordPlaceholder: 'Введите пароль',
    forgotPassword: 'Забыли пароль?',
    noAccountRegister: 'Нет аккаунта? Зарегистрируйтесь',
    submit: 'Вход',
  },
  register: {
    title: 'Регистрация',
    usernamePlaceholder: 'Введите имя пользователя (6-12 латинских букв или цифр)',
    passwordPlaceholder: 'Введите пароль для входа (6-12 латинских букв или цифр)',
    codePlaceholder: 'Введите код приглашения',
    protocol: 'Я ознакомлен и согласен со всеми условиями «Соглашения об открытии счёта»',
    submit: 'Регистрация',
    codeRequired: 'Введите код приглашения!',
    agreementRequired: 'Отметьте ниже согласие с «Соглашением об открытии счёта»!',
  },
}
